/* eslint-disable @typescript-eslint/naming-convention */

/** Typ operacji: wstawienie, zmiana, usunięcie, wpis zbiorczy (np. import). */
export type WebFamAuditOperation = 'I' | 'U' | 'D' | 'N';

/**
 * Wpis opisu w jednym języku - tak wygląda element `event.description`
 * w wartościach dziennika.
 */
export class WebFamAuditTranslation {
    text?: string;
    language?: string;
}

/** Pojedyncza zmiana pola w obrębie jednego wpisu dziennika. */
export class WebFamAuditChange {
    field!: string;
    old?: unknown;
    new?: unknown;
    /**
     * Operacja tej konkretnej zmiany. Sklejony wpis może zawierać wiersze
     * z różnych operacji (usunięcie i dodanie nazwiska w jednym zapisie),
     * więc strona do wyświetlenia wynika z tego pola, a nie z całego wpisu.
     */
    op?: WebFamAuditOperation;
    /**
     * Etykieta zamiast nazwy pola. Używana, gdy ta sama zmiana powtarza się
     * dla wielu wierszy (np. kolejność dzieci) - wtedy wiersz opisuje osoba,
     * a nie po raz kolejny ta sama nazwa kolumny.
     */
    label?: string;
}

/** Osoba, której dotyczy wpis (dziennik całego drzewa). */
export class WebFamAuditPerson {
    id!: string;
    textid?: string;
    name?: string;
}

/** Miejsce, do którego odwołuje się wpis - żeby nie pokazywać identyfikatora. */
export class WebFamAuditPlace {
    id!: string;
    name?: string;
}

/**
 * Jeden zmieniony wiersz w obrębie wpisu. Zapis profilu potrafi w jednej
 * operacji dodać jedno nazwisko i zmienić drugie - bez podziału na wiersze
 * obie zmiany zlewałyby się w jedną nieczytelną listę pól.
 */
export class WebFamAuditItem {
    op!: WebFamAuditOperation;
    changes: WebFamAuditChange[] = [];
    /** Doprecyzowanie wiersza, np. "rodowe" przy zmianie nazwiska. */
    context?: string;
    /** Tabela wiersza - te same nazwy pól znaczą co innego w różnych tabelach. */
    table?: string;
}

export class WebFamAuditEntry {
    id!: string;
    table_name!: string;
    row_id?: string;
    operation!: WebFamAuditOperation;
    changed_at!: string;
    context?: string;
    request_id?: string;
    details?: string;
    user_id?: string;
    username?: string;
    user_fullname?: string;
    /** Wspólny klucz osoby/zdarzenia/rodziny - skleja wpisy z jednej operacji. */
    subject?: string;
    /** Klucz konkretnego wiersza - paruje usunięcie z ponownym wstawieniem. */
    row_key?: string;
    changes: WebFamAuditChange[] = [];
    persons?: WebFamAuditPerson[];
    places?: WebFamAuditPlace[];
    /** Nazwy źródeł i cytatów występujących we wpisie. */
    sources?: WebFamAuditPlace[];
    /** Zmienione wiersze - wypełniane w komponencie przy sklejaniu wpisów. */
    items: WebFamAuditItem[] = [];
}

/** Użytkownik występujący w dzienniku - do filtra. */
export class WebFamAuditUser {
    user_id!: string;
    username?: string;
    user_fullname?: string;
}

/** Filtry dziennika całego drzewa. */
export class WebFamAuditFilter {
    limit?: number;
    offset?: number;
    user?: string;
    from?: string;
    to?: string;
}
